export const formatNumericalValue = (number: number): string => {
  if (number === 0) return '0';

  if (Math.abs(number) < 1.0e-3 || Math.abs(number) >= 1.0e5) {
    return number.toExponential(2);
  }
  return number.toPrecision(3);
};
